import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "../quotation/email-module.css";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import {
  getMailTemplateApi,
  sendQuotationMailApi,
} from "../quotation/quotation-api";

import DOMPurify from "dompurify";
const ComposeLeadModal = ({ id, show, handleClose, succesError }) => {
  const [chips, setChips] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [subjectValue, setSubjectValue] = useState("");
  const [toValue, setToValue] = useState("");
  const [fromValue, setFromValue] = useState("");

  const emailEditorRef = useRef(null);

  const HtmlContent = ({ html }) => {
    // const sanitizedHtml = DOMPurify.sanitize(html);

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  };
  const [contentValue, setContentValue] = useState("");
  const [contentViewValue, setContentViewValue] = useState("");
  const [editValue, setEditValue] = useState("");
  const addChip = () => {
    const value = inputValue.trim();

    if (value === "") return;

    setChips([...chips, value]);
    setInputValue("");
  };

  const removeChip = (index) => {
    setChips(chips.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "," || e.key === " ") {
      e.preventDefault();
      addChip();
    }
  };
  const [errorMsg, setErrorMsg] = useState({
    to_email: "",
  });

  const sendMail = async () => {
    const bodyData = {
      to_email: toValue,
      cc_emails: chips,
      subject: subjectValue,
      body: contentValue,
    };
    try {
      const response = await sendQuotationMailApi(id, bodyData);
      if (response.status === 400) {
        const validationTemp = {
          to_email: "",
          cc_emails: "",
          subject: "",
          body: "",
        };
        Object.entries(response.data.error).forEach(([key, value]) => {
          if (key in validationTemp) {
            validationTemp[key] =
              Array.isArray(value) && value.length > 0 ? value[0] : "";
          }
        });
        setErrorMsg(validationTemp);
      }
      succesError(response.data);
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  const getTemplate = async () => {
    try {
      const response = await getMailTemplateApi(id);
      if (response.success === true) {
        setContentValue(response.data.body ?? "");
        setContentViewValue(response.data.body ?? "");
        setSubjectValue(response.data.subject ?? "");
        setToValue(response.data.contact_person_email ?? "");
        const emails = [
          response.data.sales_person_email,
          response.data.customer_email,
        ].filter((email) => email && email.trim() !== "");

        setChips(emails); // will be [] if both empty

        setFromValue(response.data.from_email ?? "");
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="compose-modal"
    >
      <div className="compose-box">
        {/* Header */}
        <div className="compose-header d-flex justify-content-between align-items-center">
          <span className="fs-13 fw-500">New Message</span>
          <div>
            <button onClick={handleClose} className="icon-btn">
              ✕
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="compose-content">
          {/* <div className="compose-row">
                        <label className="compose-label">From</label>

                        <input
                            type="text"
                            value={fromValue}
                            placeholder="Enter here"
                            className="compose-input fs-13 fw-600 textcolor flex-grow-1"
                            disabled
                        />

                    </div> */}
          <div className="compose-row">
            <label className="compose-label">To</label>

            <input
              type="text"
              value={toValue}
              onChange={(e) => setToValue(e.target.value)}
              placeholder="Enter here"
              className="compose-input fs-13 fw-600 textcolor flex-grow-1 no-focus-border"
            />
          </div>
          <span
            style={{
              color: "#ff4444",
              fontSize: "12px",
              fontWeight: "400",
            }}
          >
            {errorMsg.to_email}
          </span>
          <div className="compose-row">
            <label className="compose-label">CC</label>

            <div className="chip-input-wrapper flex-grow-1">
              {chips.map((chip, index) => (
                <span key={index} className="chip">
                  {chip}
                  <span
                    className="chip-close"
                    onClick={() => removeChip(index)}
                  >
                    ×
                  </span>
                </span>
              ))}

              <input
                type="text"
                className="chip-real-input fs-13 fw-600 textcolor no-focus-border"
                placeholder={chips.length === 0 ? "Enter here" : ""}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>
          <div className="compose-row">
            <label className="compose-label">Subject</label>

            <input
              type="text"
              value={subjectValue}
              onChange={(e) => setSubjectValue(e.target.value)}
              placeholder="Enter here"
              className="compose-input fs-13 fw-600 textcolor flex-grow-1 no-focus-border"
            />
          </div>

          {
            <ReactQuill
              theme="snow"
              value={contentValue}
              onChange={setContentValue}
              style={{
                width: "100%",
                minHeight: "200px",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            />
          }
        </div>

        {/* Footer */}
        <div className="compose-footer d-flex justify-content-between align-items-center">
          {/* LEFT SIDE */}
          {/* <div className="d-flex align-items-center gap-2">
                        <input type="checkbox" id="includeFiles" className="footer-checkbox" />
                        <label htmlFor="includeFiles" className="fs-13 fw-500 textcolor">
                            Include attachment
                        </label>
                    </div> */}

          {/* RIGHT SIDE BUTTON */}
          <Button onClick={sendMail} className="send-btn">
            Send
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ComposeLeadModal;
